import { useContext, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { trackAnalyticsEvent } from 'actions/analytics';
import { ANALYTICS_PROPERTIES } from 'lib/analytics';
import { ModalOpenContext } from './ModalOpenContext';

type Props = {
  event: string;
  step: string;
  stepNumber?: number;
  properties?: Record<string, unknown>;
};

// The workflow modals stay mounted while closed, so a step only counts as
// viewed while its modal is open.
const TrackStepViewed = ({ event, step, stepNumber, properties }: Props) => {
  const isOpen = useContext(ModalOpenContext);
  const dispatch = useDispatch<any>();
  const latest = useRef({ stepNumber, properties });
  latest.current = { stepNumber, properties };

  useEffect(() => {
    if (!isOpen) return;
    dispatch(
      trackAnalyticsEvent(event, {
        [ANALYTICS_PROPERTIES.STEP]: step,
        [ANALYTICS_PROPERTIES.STEP_NUMBER]: latest.current.stepNumber,
        ...latest.current.properties,
      }),
    );
  }, [dispatch, event, isOpen, step]);

  return null;
};

export default TrackStepViewed;
